import {ReportData} from "../../../reports/report.data";
import {collection} from "@fedeltapointofsale/data-client";
import {InventoryReportSelectionData} from "../../inventory/controls/inventory-report-selection-control.component";
import {InventoryCustomObjectReportSelectionData} from "../../../custom-objects/custom-object/controls/inventory-custom-object-report-selection-control.component";

export class UncountedStockReportData extends ReportData<UncountedStockReportData> {
    @collection(InventoryReportSelectionData) inventories: InventoryReportSelectionData[];
    @collection(InventoryCustomObjectReportSelectionData) customObjects: InventoryCustomObjectReportSelectionData[];
}
